import { useState } from "react";

export const useFormFields = (initial, validators) => {
  const [form, setForm] = useState(initial);
  const [errors, setErrors] = useState({});

  const set = (key, value) => {
    setForm((f) => ({ ...f, [key]: value }));
    setErrors((e) => ({ ...e, [key]: undefined }));
  };

  const validate = (extra = {}) => {
    const e = {};
    Object.entries(validators).forEach(([key, check]) => {
      const msg = check(form[key], form, extra);
      if (msg) e[key] = msg;
    });
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const reset = () => setForm(initial);
  const setError = (key, msg) => setErrors((e) => ({ ...e, [key]: msg }));

  return { form, errors, set, validate, reset, setError };
};

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
